<style>
   .it {
        width           : 450px;
        display         : flex;
        flex-direction  : column;
        justify-content : center;
        align-content   : center;
        margin          : 1em;
        color           : white;
    }

    .it > div, .it ul {
        margin-bottom: 1em;
    }

    .ui.label {
        width: 100px;
        background-color: #fff;
        border-right: 1px solid #ddd;
    }

    li {
      list-style-type: none;
    }

    li.valid {
        text-decoration: line-through;
        color: #ddd;
    }
</style>

<script>
    import { post }     from './shared/api'

    export let onActivated

    const params = new URLSearchParams(window.location.search)

    let password = '' 
    let repeat   = ''
    let email    = params.get('email')
    let code     = params.get('cod')
    let loading  = false
    let error    = false

    $: lower   = /[a-z]/.test(password)
    $: upper   = /[A-Z]/.test(password)
    $: number  = /.*[0-9].*/.test(password)
    $: length  = (password.length >= 8 && password.length <= 16)
    $: special = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)
    $: same    = repeat === password
    $: fresh   = code != '' && code !== password
    $: allowed = lower && upper && number && length && special && same && fresh

    function login() {
        return post('/user/login', { email: email, password: password })
            .then(res => {
                loading = false
                if(res.status === 200) {
                    onActivated(true)
                } else {
                    onActivated(false)
                }
            })
            .catch(err => {
                loading = false
                onActivated(false)
            })
    }

    function changePassword() {
        
        const data = { 
            email       : email, 
            old         : code ,
            replacement : password 
        }

        loading = true
        return post('/user/password/change', data)
            .then(res => {
                if(res.status === 200) {
                    login()
                } else {
                    loading = false
                    error = true
                    setTimeout(() => {
                        error = false
                    }, 3000)
                }
            })
    }

</script>

<div class="it">

    <h3>
        Olá <u>{email}</u>. <br/>
        A sua senha precisa ter os seguintes itens:
    </h3>

    <ul class="rules">
        <li class:valid={lower}   >               Pelo menos um caracter minúsculo </li>
        <li class:valid={upper}   >               Pelo menos um caracter maiúsculo </li>
        <li class:valid={length}  >               Entre 8 e 16 caracteres          </li>
        <li class:valid={number}  >               Pelo menos um número             </li>
        <li class:valid={special} >               Pelo menos um caracter especial  </li>
        <li class:valid={allowed} >               A senha precisa ser nova         </li>
        <li class:valid={same && repeat !== ''} > As senhas precisam ser iguais </li>
    </ul>

    <div class="ui labeled big input" class:disabled={loading || error}>
        <div class="ui label">Senha</div>
        <input  type="password" 
                bind:value={password} 
                placeholder="senha segura"
                autocomplete="false">
    </div>

    <div class="ui labeled big input" class:disabled={loading || error}>
        <div class="ui label">Senha</div>
        <input  type="password" 
                bind:value={repeat} 
                placeholder="repita a senha"
                autocomplete="false">
    </div>

    {#if error}
        <h3 style="text-align: right;">Erro ao Cadastrar!</h3>
    {:else}
        <button class="ui big blue button" 
                on:click={changePassword} 
                class:loading
                class:disabled={!allowed || loading || error}>
            Cadastrar
        </button>
    {/if}
</div>